import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { isEditingLockedStatus } from "@redotech/redo-fulfillment-group-common/fulfillment-group-status";
import { OutboundParcel } from "@redotech/redo-fulfillment-parcel-common/parcel";
import { FulfillmentGroupUpdate } from "@redotech/redo-merchant-fulfillment-rpc/schema/update-fulfillment-groups";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { AdditionalFulfillmentSettings } from "../../common/additional-fulfillment-settings";
import { useFulfillmentGroupPermissions } from "../../utils/use-assigned-fulfillment-service";

export const AdditionalSettingsCard = memo(function AdditionalSettingsCard({
  fulfillmentGroup,
  fulfillmentDate,
  handleUpdates,
  parcelBeingEdited,
  updateParcel,
  disableBulkParcelEditing,
}: {
  fulfillmentGroup: FulfillmentGroupData;
  fulfillmentDate: Date | null;
  handleUpdates: (updates: FulfillmentGroupUpdate[]) => void;
  parcelBeingEdited: OutboundParcel;
  updateParcel: (parcel: Partial<OutboundParcel>) => void;
  disableBulkParcelEditing?: boolean;
}) {
  const { permissionsToEditEveryGroup } = useFulfillmentGroupPermissions([
    fulfillmentGroup,
  ]);

  const isEditingLocked = isEditingLockedStatus(fulfillmentGroup.status);

  return (
    <Flex
      bgColor="primary"
      borderColor="secondary"
      borderRadius="lg"
      borderStyle="solid"
      borderWidth="1px"
      dir="column"
      flexDirection="column"
      gap="3xl"
      p="3xl"
      w="full"
    >
      <Text color="secondary" fontSize="sm" fontWeight="medium">
        Additional shipping settings
      </Text>
      <AdditionalFulfillmentSettings
        disableBulkSettingsEditing={disableBulkParcelEditing}
        everythingDisabled={!permissionsToEditEveryGroup}
        fulfillmentDate={fulfillmentDate}
        fulfillmentGroups={[fulfillmentGroup]}
        isEditingLockedStatus={isEditingLocked}
        parcelBeingEditedPerGroup={[parcelBeingEdited]}
        updateParcel={updateParcel}
        updateRows={handleUpdates}
      />
    </Flex>
  );
});
